/**
 * Created by heshufen on 22/10/13.
 */
import React from 'react'
import {Image, Text} from '../../../../components'
import Vertical from "../../../../components/layouts/Vertical";
import {imageCut} from "../../../../components/Image";
import {connect} from "react-redux";
import * as ActionTypes from "../../ActionTypes";
import {getProductListByTag} from "../../actions";

class ProductListScreen extends React.Component {
    async componentDidMount() {
        this.init()
        window.addEventListener('scroll', this.handleScroll);
    }

    async init() {
        const {position, products} = this.props;
        if (position && products && products.length > 0) {
            window.scrollTo(0, position)
        } else {
            await this.props.getProducts(this.props.match.params._id, this.props.match.params._pid);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll = async (e) => {
        const dEnd = (document.body.offsetHeight - window.scrollY) - window.screen.height
        if (dEnd < 20) {
            await this.props.getProducts(this.props.match.params._id, this.props.match.params._pid, true);
        }
    };

    toDetail = (product) => {
        this.props.savePosition(window.scrollY);
        this.props.history.push('/' + product.userId + '/detail/' + product._id)
    };

    render() {
        return (
            <Vertical className={'portfolio home'}>
                <div className={'list'}>
                    {this.props.products.map((product, i) => {
                        return <div key={i} className={'product'}>
                            <Image
                                onClick={() => this.toDetail(product)}
                                source={{uri: imageCut(product.images[0], {width: 150, height: 220})}}
                                className={'img'}/>
                            <Vertical style={styles.imageCountWrapper}>
                                <Text style={styles.title}>{product.title}</Text>
                                <Text style={styles.imageCount}>{product.images.length} 张图</Text>
                            </Vertical>
                        </div>
                    })}
                </div>
            </Vertical>
        )
    }
}

export default connect((state) => {
    return {
        position: state.app.position_product_list,
        products: state.app.productList || [],
    }
}, (dispatch) => {
    return {
        savePosition: (position) => dispatch({type: ActionTypes.SAVE_POSITION_PRODUCT_LIST, position}),
        getProducts: (userId, tag, loadMore = false) => {
            return dispatch(getProductListByTag(userId, tag, loadMore))
        },
    }
})(ProductListScreen);


const styles = {
    imageCountWrapper: {
        // backgroundColor: 'rgba(0,0,0,0.7)',
        backgroundColor: '#f8f8f7',
        height: 74,
        marginTop: -5,
        width: '95%',
        marginLeft: '5%',
        marginBottom: 15,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
    },
    title: {
        color: '#000000',
        fontSize: 15,
        marginLeft: 13,
        marginTop: 16,
        fontWeight: '500'
    },
    imageCount: {
        fontSize: 11,
        color: "#717171",
        marginTop: 5,
        marginLeft: 13,
    },
}



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/product/ProductListScreen.js